import React, { memo, useEffect,  useMemo,  useState} from 'react';
// import { Dayjs } from 'dayjs';
import * as Dayjs from 'dayjs'
import DatePicker from "react-datepicker";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import { isMath, isNormalZhEnCss } from "../../utils";
import DestinationCity from './components/DestinationCity';
import * as TYPES from '../../models/types';

import PlanTravelModel from '../PlanTravelModel';

import 'swiper/css';
import "react-datepicker/dist/react-datepicker.css";
import styles from './styles.module.scss';


const Index = memo((props) => {
  const dispatch = useDispatch();
  
  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { lang, planTravel, customProcessSteps } = useSelector(({localesReducer}) => localesReducer.i18n);
  const domesticOverseasContact = useSelector(({domesticOverseasContactReducer}) => domesticOverseasContactReducer);
  const domesticOverseasContactReducer = useSelector(({domesticOverseasContactReducer}) => domesticOverseasContactReducer);
  const { config } = props;

  const [startDate, setStartDate] = useState(new Date());

  const [ initialSlideVal, setInitialSlideVal ] = useState(config.options.status);
  const [swiperRef, setSwiperRef] = useState('');
  const [lineWidth, setLineWidth] = useState(26);
  const [noOfPaxNum, setNoOfPaxNum] = useState('');
  const [noOfDaysKey, setNoOfDaysKey] = useState('');
  const [noOfDaysVal, setNoOfDaysVal] = useState('');
  // const [destinationCityList, setDestinationCityList] = useState([]);
  const [destinationCityList, setDestinationCityList] = useState([]);
  const [destinationCity, setDestinationCity] = useState('');
  const [cityHeightVal, setCityHeightVal] = useState(50);
  

  const [stepsCounterList, setStepsCounterList] = useState([
    {
      id: 1001,
      active: 'stepsActive',
      status: true,
    },
    {
      id: 1002,
      active: 'stepsActive',
      status: false,
    },
    {
      id: 1003,
      active: 'stepsActive',
      status: false,
    },
  ]);

  const noOfPaxNums = [
    {
      id: 1,
      width: 26,
      widthm: 28,
    },
    {
      id: 2,
      width: 88,
      widthm: 95,
    },
    {
      id: 3,
      width: 150,
      widthm: 164,
    },
    {
      id: 4,
      width: 212,
      widthm: 232,
    },
    {
      id: 5,
      width: 275,
      widthm: 299,
    },
    {
      id:6,
      width: 336,
      widthm: 367,
    },
    {
      id: 7,
      width: 398,
      widthm: 435,
    },
    {
      id: 8,
      width: 460,
      widthm: 501,
    },
    {
      id: 9,
      width: 522,
      widthm: 570,
    },
    {
      id: 10,
      width: 589,
      widthm: 641,
    },
  ];


  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setCityHeightVal(50);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setCityHeightVal(50);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setCityHeightVal(50);
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setCityHeightVal(50);
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setCityHeightVal(64);
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  }, []);


  useEffect(() => {
     if(domesticOverseasContactReducer.chooseName === 'domesticTitle'){
      const list = customProcessSteps.stepsOne.destination.domestic.list.map(item => item.title);
      setDestinationCityList(list);
     }else{
      const list = customProcessSteps.stepsOne.destination.overseas.list.map(item => item.title);
      setDestinationCityList(list);
     }
    
  }, [domesticOverseasContactReducer, config, customProcessSteps.stepsOne]);

  // 获取 目的地* 数据
  const handleDestinationCity = (res) => {
    setDestinationCity(res);
  }

  // 日期
  const handleChangeDatePicker = (date) => {
    setStartDate(date);
  };


  const [stepsOneData, setStepsOneData] = useState(null);
  const [stepsTwoData, setStepsTwoData] = useState(null);
  const [stepsThreeData, setStepsThreeData] = useState(null);

  // 第 一 页的数据：
  const [stepsOneFlag, setStepsOneFlag] = useState(false);
  const handleStepsOneForm = (callback) => {
    const stepsOneObj = {
      chooseName: domesticOverseasContact.chooseName,  // 目的地
    };

    setStepsOneData(stepsOneObj);
    if(stepsOneObj.chooseName) {
      setStepsOneFlag(true);
      setInitialSlideVal(1);
      swiperRef.slideTo(1); // status
      callback(stepsOneObj);
    }else{
      setStepsOneFlag(false);
      setInitialSlideVal(1);
      swiperRef.slideTo(0); // status
      callback(stepsOneObj);
    }
  }

  // 第 二 页的数据：
  const [stepsTwoFlag, setStepsTwoFlag] = useState(false);
  const handleStepsTwoForm = (callback) => {
    const stepsTwoObj = {
      cityList: destinationCity,  // 目的地
      noOfDays: noOfDaysVal,  // 天数
      noOfPax: noOfPaxNum,  // 天数
      dateTime: startDate ? Dayjs(startDate).format('YYYY-MM-DD HH:mm:ss') : startDate,
    };

    setStepsTwoData(stepsTwoObj);
    if(stepsTwoObj.cityList.textareaVal === '' ||  stepsTwoObj.noOfDays === '' || stepsTwoObj.dateTime === '' ){
      setStepsTwoFlag(false);
      setStepsTwoFlag(initialSlideVal);
      swiperRef.slideTo(1); // status
      callback(stepsTwoObj);
    }else{
      setStepsTwoFlag(true);
      setInitialSlideVal(2);
      swiperRef.slideTo(2); // status
      callback(stepsTwoObj);
    }
  }


  // 第 三 页的数据：
  const [travelRequestVal, setTravelRequestVal] = useState('');  // 旅游需求
  const [travelNameVal, setTravelNameVal] = useState('');  // 姓名
  const [mobileVal, setMobileVal] = useState(''); // 电话 
  const [isMobileFlag, setIsMobileFlag] = useState(false); // 是不是有效电话 
  const [stepsThreeFlag, setStepsThreeFlag] = useState(false);
 
  const handleStepsThreeForm = (callback) => {
    const stepsThreeObj = {
      travelRequest: travelRequestVal,  // 旅游需求
      travelName: travelNameVal,  // 姓名
      mobile: mobileVal,  // 电话
    };
    setStepsThreeData(stepsThreeObj);
    if(stepsThreeObj.travelName === '' ||  isMobileFlag === false) {
      setStepsThreeFlag(false);
      setInitialSlideVal(2);
      swiperRef.slideTo(2); // status
      callback(stepsThreeObj);
    }else{
      setStepsThreeFlag(true);
      setInitialSlideVal(3);
      swiperRef.slideTo(3); // status
      callback(stepsThreeObj);
    }
  }

   // 提交数据
   const handleOnSubmit = (callback) => {
    switch(initialSlideVal){
      case 0: 
       handleStepsOneForm((res) => {
          if(stepsOneFlag){
            callback(res);
          }
        });
      
        break;
      case 1: 
       handleStepsTwoForm((res) => {
          if(stepsTwoFlag){
            callback(res);
          }
        });
       
        break;
      case 2: 
         handleStepsThreeForm((res) => {
            if(stepsThreeFlag){
              callback(res);
            }
         });
        break;
      default:
        callback({});

    }

  }


   // 对国内/国外/联系 进行判断处理  domesticOverseasContact.chooseName, // 目的地
   const isDomesticOverseasContactChoose = (callback) => {
    // "domesticTitle" / "overseasTitle" / "contactTitle"
    if(domesticOverseasContact.chooseName === TYPES.contactTitle){
      handleStepsThreeForm((res) => {
        if(stepsThreeFlag){
          callback(res);
        }
     });
    }else{
      handleOnSubmit((res) => {
        callback(res);
      });
    }
  }

  const stepsOneRender = () => {
    const { stepsOne } = customProcessSteps;
      return (
        <div className="swiperSlideInnerBox">
            <form>
              {/* 目的地 */}
              <div className="item">
                  <DestinationCity
                    config={{
                      recReSizeReducer,
                      data: destinationCityList,
                      stepsOne,
                      handleChange: handleDestinationCity,
                      cityHeightVal,
                    }}
                  />
              </div>
              {/* 天数 */}
              <div className="item">
                  <div className="row">
                    <div className="col"><span>{stepsOne.noOfDays.content.name}</span><i>*</i></div>
                    <div className="col">
                        <ul className="colList">
                            {stepsOne.noOfDays.list.map(item => <li key={item.id} className={item.id === noOfDaysKey ? 'colLiActive' : null} onClick={() => handlenClickOfDays(item)}><span>{item.title}</span></li>)}
                        </ul>
                    </div>
                  </div>
                  {noOfDaysKey ? null : <div className="row"><span className='error'>{stepsOne.destination.message}</span></div>}
                  
              </div>
              {/* 人数 */}
              <div className="item">
                  <div className="row">
                    <div className="col"><span>{stepsOne.noOfPax.content.name}</span></div>
                    <div className="col">
                        <div className="lineBox">
                            <div className="line" style={{transition: 'all .5s', width: isMath(recReSizeReducer, lineWidth)}}>
                                <i />
                            </div>
                        </div>
                        <div className="lineNumBox">
                            { noOfPaxNums.map((item, index) => {
                              return <em key={item.id} onClick={() => handleNoOfPaxNum(item)}>{item.id}</em>
                            })}
                        </div>
                    </div>
                  </div>
              </div>
              {/* 出发日期*  */}
              <div className="item">
                  <div className="row">
                    <div className="col"><span>{stepsOne.departureDate.content.title}</span><i>*</i></div>
                    <div className="col">
                        <div className="datepickerBox">
                            <DatePicker
                              popperClassName="some-custom-class"
                              popperPlacement="top-end"
                              selected={startDate}
                              onChange={handleChangeDatePicker}
                              // onCalendarClose={handleCalendarClose}
                              // onCalendarOpen={handleCalendarOpen}
                              timeInputLabel="Time:"
                              // dateFormat="MM-dd-yyyy h:mm aa"
                              dateFormat="yyyy-MM-dd h:mm aa"
                              showTimeInput
                              placeholderText={stepsOne.departureDate.content.placeholder}
                            />
                            <svg className="datepickerIcon" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M15.7222 2H15.2234V0.99C15.2234 0.44 14.7845 0 14.2358 0H14.2159C13.6672 0 13.2283 0.44 13.2283 0.99V2H5.24766V0.99C5.24766 0.44 4.80873 0 4.26006 0H4.24011C3.69144 0 3.2525 0.44 3.2525 0.99V2H2.75371C1.37705 2 0.259766 3.12 0.259766 4.5V15.5C0.259766 16.88 1.37705 18 2.75371 18H15.7222C17.0989 18 18.2162 16.88 18.2162 15.5V4.5C18.2162 3.12 17.0989 2 15.7222 2ZM16.221 15.5C16.221 15.78 16.0016 16 15.7222 16H2.75371C2.47439 16 2.25492 15.78 2.25492 15.5V8.5C2.25492 8.22 2.47439 8 2.75371 8H15.7222C16.0016 8 16.221 8.22 16.221 8.5V15.5Z" fill="#999999"/>
                            </svg>
                        </div>
                    </div>
                  </div>
                  {startDate ? null : <div className="row"><span className='error'>{stepsOne.departureDate.message}</span></div>}
              </div>
            </form>
        </div>
      )
  }


  const handlenClickOfDays = (parmas) => {
    setNoOfDaysKey(parmas.id);
    setNoOfDaysVal(parmas);
  }

  const handleNoOfPaxNum = (parmas) => {
    const val = recReSizeReducer <= 750 ? parmas.widthm : parmas.width;
    setLineWidth(val);
    setNoOfPaxNum(parmas);
  }

  const handleTravelRequest = (event) => {
    const val = event.target.value;
    setTravelRequestVal(val.trim());
  }

  const handleTravelName = (event) => {
    const val = event.target.value;
    setTravelNameVal(val.trim());
  }

  const handleMobile = (event) => {
    const reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    const val = event.target.value;
    setMobileVal(val.trim());
    if(reg.test(val)){
      setIsMobileFlag(true);
    }else{
      setIsMobileFlag(false);
    }
    
  }

  const stepsTwoRender = () => {
    const { stepsTwo } = customProcessSteps;
      return (
        <div className="swiperSlideInnerBox">
              {/* 旅游需求  */}
              <div className="item travelRequest">
                  <div className="row">
                    <div className="col"><span>{stepsTwo.travelRequest.content.title}</span></div>
                    <div className="col">
                        <div className="textareaBox">
                          <textarea 
                              rows="1"
                              cols="1"
                              placeholder={stepsTwo.travelRequest.content.placeholder}
                              value={travelRequestVal}
                              onChange={handleTravelRequest}
                          />
                        </div>
                    </div>
                  </div>
              </div>
              {/* 姓名*  */}
              <div className="item travelName">
                  <div className="row">
                    <div className="col"><span>{stepsTwo.travelName.content.title}</span><i>*</i></div>
                    <div className="col">
                        <div className="userName">
                          <input 
                            type="text" 
                            placeholder={stepsTwo.travelName.content.placeholder}
                            value={travelNameVal}
                            onChange={handleTravelName}
                          />
                        </div>
                    </div>
                  </div>
                  {travelNameVal ? null : <div className="row"><span className='error'>{stepsTwo.travelName.message}</span></div>}
              </div>
              {/* 电话*  */}
              <div className="item mobile">
                  <div className="row">
                    <div className="col"><span>{stepsTwo.mobile.content.title}</span><i>*</i></div>
                    <div className="col">
                        <div className="tel">
                          <input 
                            type="tel" 
                            placeholder={stepsTwo.mobile.content.placeholder}
                            value={mobileVal}
                            onChange={handleMobile}
                          />
                        </div>
                    </div>
                  </div>
                  {
                    mobileVal ? isMobileFlag ? null :  <div className="row"><span className='error'>{stepsTwo.mobile.messages.msg}</span></div> :  <div className="row"><span className='error'>{stepsTwo.mobile.messages.title}</span></div>
                  }
                 
              </div>
        </div>
      )
  }

  const stepsThreeRender = () => {
    const { stepsThree } = customProcessSteps;
      return (
        <div className="swiperSlideInnerBox">
              {/* 提交成功 */}
              <div className="successfully">
                <h5><span>{stepsThree.content.title}</span></h5>
                <p><span>{stepsThree.content.titleSub}</span></p>
              </div>
        </div>
      )
  }

   // 对上一步的数据处理
  const handleButPrev = () => {
    if(domesticOverseasContact.chooseName === TYPES.contactTitle){
      swiperRef.slideTo(0);
    }else{
      swiperRef.slideTo(initialSlideVal-1);
    }

  }

  const handleButNext = () => {
    // handleOnSubmit((res) => {})
    isDomesticOverseasContactChoose((res) => {});
    
  }

  console.log("提交后的数据: ", {stepsOneData, stepsTwoData, stepsThreeData});

  const slideChangeMethod = (activeIndex) => {
    setInitialSlideVal(activeIndex);
    switch(activeIndex){
      case 1: 
        setStepsCounterList([
          {
            id: 1001,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1002,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1003,
            active: 'stepsActive',
            status: false,
          },
        ]);
        break;
      case 2: 
        setStepsCounterList([
          {
            id: 1001,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1002,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1003,
            active: 'stepsActive',
            status: true,
          },
        ]);
        break;
      case 3: 
        setStepsCounterList([
          {
            id: 1001,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1002,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1003,
            active: 'stepsActive',
            status: true,
          },
        ]);
        break;
      default:
        setStepsCounterList([
          {
            id: 1001,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1002,
            active: 'stepsActive',
            status: true,
          },
          {
            id: 1003,
            active: 'stepsActive',
            status: true,
          },
        ]);

    }
  }

  //  // stepsOneFlag / stepsTwoFlag / stepsThreeFlag

  const swiperSlideSetStyleMethod = (swiper) => {
    if(recReSizeReducer <= 750 ){
       // 1 true 790  false 990
      const swiperSlideTwoCss = recReSizeReducer <= 750 ?  isMath(recReSizeReducer, 990) : null;
      const swiperSlideThreeCss = recReSizeReducer <= 750 ?  isMath(recReSizeReducer, 830) : null;
      const swiperSlideFourCss = recReSizeReducer <= 750 ?  isMath(recReSizeReducer, 280) : null;
      const activeIndex = swiper.activeIndex;
      switch(activeIndex){
        case 1:
          swiper.$wrapperEl[0].style.height = swiperSlideTwoCss;
          break;
        case 2:
          swiper.$wrapperEl[0].style.height = swiperSlideThreeCss;
          break;
        case 3:
          swiper.$wrapperEl[0].style.height = swiperSlideFourCss;
          break;
        default:
          swiper.$wrapperEl[0].style.height = 'auto';
      }
    }
    
  }

  const planTravelModelCom = () => {
    const {status} = config.options;
    switch(status){
      case 1:
        return null;
      case 2:
        return null;
      case 3:
          return null;
      default:
        return <PlanTravelModel />;
    }
   
  }
  const stepsOneRenderCom = () => {
    const {status} = config.options;
    switch(status){
      case 1:
        return stepsOneRender();
      case 2:
        return null;
      case 3:
          return null;
      default:
        return stepsOneRender();
    }
   
  }

  const stepsTwoRenderCom = () => {
    return stepsTwoRender();
  }

  // 轮播区域内容
  const processStepsSwiper = () => {
    return (
      <Swiper
        className="processStepsSwiper swiper-no-swiping"
        onInit={(swiper) => {
          setSwiperRef(swiper);
          swiperSlideSetStyleMethod(swiper);
        }}
        onSlideChange={(swiper) => {
          const activeIndex = swiper.activeIndex;
          swiperSlideSetStyleMethod(swiper);
          slideChangeMethod(activeIndex);
        }}
      >
        <SwiperSlide>{planTravelModelCom()}</SwiperSlide>
        <SwiperSlide>{stepsOneRenderCom()}</SwiperSlide>
        <SwiperSlide>{stepsTwoRenderCom()}</SwiperSlide>
        <SwiperSlide>{stepsThreeRender()}</SwiperSlide>
      </Swiper>
    );
  }


  const processStepsMTop = () => {
    switch(initialSlideVal){
      case 1: 
        return 100;
      case 2: 
        return 100;
      case 3: 
        return 446;
      default: 
        return 0;
    }
  }

  const isStepsCounterMethod = () => {
    if(domesticOverseasContact.chooseName === TYPES.contactTitle){
      return null;
    }else{
      return initialSlideVal === 3 ? null : (
        <div className="stepsCounter">
        {stepsCounterList.map(item => {
          if(item.status){
            return <i key={item.id} className={item.active} />
          }else{
            return <i key={item.id} />
          }
        })}
      </div>
     )
    }
  }

  // 头部
  const processStepsTop = () => {
    const {
      titleTwo,
      links,
    } = planTravel.findCaseYouLink;

    const processStepsTopCss = recReSizeReducer <= 750 ? { paddingTop: isMath(recReSizeReducer, processStepsMTop())} : null;// 446
    
    return (
      <div className='processStepsTop' style={processStepsTopCss}>
            <h5 className="title"><span>{titleTwo}</span></h5>
            {initialSlideVal === 3 ? null : <p className="subTitle"><span>{links[2].tabTitle}</span></p> }
            { isStepsCounterMethod() }
      </div>
    );
  }


  const buttonPrevRender = () => {
    return (
      <div className="buttonPrev" onClick={handleButPrev}>
          <svg  className="buttonPrevIcon" width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.5">
                <path d="M5.21687 0.782959L1 4.99983L5.21687 9.21669" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M1.5 5L15.5 5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
          </svg>
          <span>prev</span>
      </div>
    )
  }

  // 对不同的页面打开 定制流程 进行判断 显示按钮
  const butPrevBtn = () => {
    const {status} = config.options;
    if(status === 1){
      if(initialSlideVal > 1){
        return buttonPrevRender();
      }else{
        return null
      }
    } else if(status === 2){
      if(initialSlideVal > 2){
        return buttonPrevRender();
      }else{
        return null
      }
    } else{
      if(initialSlideVal > 0){
        return buttonPrevRender();
      }else{
        return null
      }
    }
   
  }


  // 提交方法的判断
  const handleBtnSubmit = () => {
    const {handleClone} = props;
    if(initialSlideVal > 2){
      handleClone();
    }else{
      handleButNext();
    }
  }

  const btnNextPrevRender = () => {
    return (
      <div className="btnNextPrevBox">
         {/* 控制轮播区域 */}
          { initialSlideVal > 2 ? null : butPrevBtn() }
          <div className="buttonNext" onClick={handleBtnSubmit}>
              <span>{ initialSlideVal === 3 ? 'ok' : 'next step'}</span>
              <svg className="buttonNextIcon" width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.2831 9.21704L15.5 5.00017L11.2831 0.783307" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 5L1 5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
          </div>
      </div>
    );
  }


  

  // 桌面/移动端
  const desktopsMobiles = () => {
    return processStepsSwiper();
    // return processStepsSwiperNew();
  }

  const destroyData = () => {
      setLineWidth('26');
      setNoOfPaxNum('');
      setNoOfDaysKey('');
      setNoOfDaysVal('');
      setDestinationCity('');
      setDestinationCity('');

      setStepsOneFlag(false);
      setStepsTwoFlag(false);
      setStepsThreeFlag(false);
      setIsMobileFlag(false);

      setTravelRequestVal('');
      setTravelNameVal('');
      setMobileVal('');
      setIsMobileFlag(false);
      setStepsThreeFlag(false);
      setStepsOneData(null);
      setStepsTwoData(null);
      setStepsThreeData(null);
  }

  
  useEffect(() => {
    const {status} = config.options;
    setTimeout(() => {
      if(swiperRef){
        setInitialSlideVal(status);
        swiperRef.slideTo(status); // status
      }
    }, 100);

    return () => {
      destroyData();
    }
  }, [config.options, swiperRef]);

  return (
      <div className={normal} style={ recReSizeReducer <= 750 ? (initialSlideVal === 0 ? {paddingTop: isMath(recReSizeReducer, 100) }: null) : null}>
        {initialSlideVal === 0 ? null : processStepsTop()}
        {desktopsMobiles()}
        {btnNextPrevRender()}
      </div>
  );
});
export default Index;
